import { render, staticRenderFns } from "./EmployeePoints.vue?vue&type=template&id=02e91c74&"
import script from "./EmployeePoints.vue?vue&type=script&lang=js&"
export * from "./EmployeePoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports